const { SERVICE_STATUSES } = require('../../../../constants');

/**
 * Pure guard to determine if the chat modal should automatically open upon driver assignment.
 * Does NOT depend on payload.old (which only contains PK when RLS is active).
 *
 * @param {string|null} prevStatus - The previously recorded status known by the client
 * @param {string} nextStatus - The new status received in the update
 * @returns {boolean}
 */
function shouldAutoOpenChat(prevStatus, nextStatus) {
  if (!prevStatus || !nextStatus) return false;
  const searchingStatus = SERVICE_STATUSES?.SEARCHING || 'searching';
  const assignedStatus = SERVICE_STATUSES?.DRIVER_ASSIGNED || 'driver_assigned';

  return prevStatus === searchingStatus && nextStatus === assignedStatus;
}

/**
 * Pure guard to determine if a counter-offer modal should be presented to the passenger.
 * Deduplicates by service_id and offered_price so repeated updates or row syncs do not re-trigger it.
 *
 * @param {string|null} lastShownKey - Key of the counter-offer previously acknowledged/shown
 * @param {object} row - The new service row payload
 * @returns {{ show: boolean, key: string|null }}
 */
function shouldShowCounterOffer(lastShownKey, row) {
  if (!row) return { show: false, key: lastShownKey };

  const assignedStatus = SERVICE_STATUSES?.DRIVER_ASSIGNED || 'driver_assigned';
  const isDriverAssigned = row.status === assignedStatus;
  const hasCounterOffer = Number(row.counter_offer_count || 0) > 0;
  const hasOfferedPrice = row.offered_price != null && !isNaN(Number(row.offered_price));

  if (!isDriverAssigned || !hasCounterOffer || !hasOfferedPrice) {
    return { show: false, key: lastShownKey };
  }

  const sid = row.service_id || row.id;
  const currentKey = `${sid}_${row.offered_price}`;

  if (lastShownKey === currentKey) {
    return { show: false, key: currentKey };
  }

  return { show: true, key: currentKey };
}

module.exports = {
  shouldAutoOpenChat,
  shouldShowCounterOffer
};
